export enum ModalKey {
  CHANGE_EMAIL = 'CHANGE_EMAIL',
  PASSWORD = 'PASSWORD',
  ACTIVITY = 'ACTIVITY',
  CONNECTED_APP = 'CONNECTED_APP',
}
